import { z } from 'zod';
import { FiatCurrencySchema } from '../types/FiatCurrency.types';
import { OfferPresentationSchema, ProductAssetDtoSchema } from './bundleOffers.schema';

export const CurrencyEnum = FiatCurrencySchema;

// Bundle DTO Schema
export const BundleDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  alias: z.string().optional(),
  priority: z.number(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number(),
  price: z.number(),
  cover: ProductAssetDtoSchema,
  isActive: z.boolean(),
  beforeSalePrice: z.number().optional(),
  presentationOfferConfig: OfferPresentationSchema.nullish(),
});

// TODO: need to check if this valid
export const OrderBundleDtoSchema = z.object({
  id: z.string().uuid(),
  goldCoins: z.number(),
  sweepCoins: z.number(),
  bonusSweepCoins: z.number().optional(),
  price: z.number(),
  isSale: z.boolean(),
  salePrice: z.number().nullable(),
  currency: CurrencyEnum,
});

export type BundleUIModel = z.infer<typeof BundleDtoSchema>;
export type OrderBundleDto = z.infer<typeof OrderBundleDtoSchema>;
